import type { CycleEvaluation } from '@/types/cycle-evaluation/CycleEvaluation';
import type {
    CycleEvaluationGroup,
    CycleEvaluationGroupChild,
} from '@/types/cycle-evaluation/CycleEvaluationGroup';

import {
    EvaluationType,
    type EvaluationTypeValue,
} from '@/constants/cycle-evaluation/CycleEvaluation';

export interface EvaluationElementsSelection {
    managerAssessment: boolean;
    feedback360: boolean;
    selfAssessment: boolean;
    assessOrganizationalValues: boolean;
    templateIds: Partial<Record<EvaluationTypeValue, string>>;
}

export const STEP_COUNT_DRIVING_EVALUATION_TYPE: EvaluationTypeValue =
    EvaluationType.EVALUATION_360;

export const EVALUATION_TYPE_ORDER: readonly EvaluationTypeValue[] = [
    EvaluationType.MANAGER_EVALUATION,
    EvaluationType.EVALUATION_360,
    EvaluationType.SELF_EVALUATION,
];

export const getSelectedEvaluationTypes = (
    selection: EvaluationElementsSelection,
): EvaluationTypeValue[] => {
    const checkedByType: Record<EvaluationTypeValue, boolean> = {
        [EvaluationType.MANAGER_EVALUATION]: selection.managerAssessment,
        [EvaluationType.EVALUATION_360]: selection.feedback360,
        [EvaluationType.SELF_EVALUATION]: selection.selfAssessment,
    };

    return EVALUATION_TYPE_ORDER.filter((type) => checkedByType[type]);
};

export const selectionIncludesFeedback360 = (selection: EvaluationElementsSelection): boolean =>
    getSelectedEvaluationTypes(selection).includes(STEP_COUNT_DRIVING_EVALUATION_TYPE);

export const isTemplateRequiredFor = (type: EvaluationTypeValue): boolean =>
    type !== EvaluationType.MANAGER_EVALUATION;

export const hasCycleEvaluationBeenSent = (evaluation?: CycleEvaluation): boolean =>
    Boolean(evaluation?.processedAt);

export const findAttachedGroupEvaluation = (
    group: CycleEvaluationGroup | undefined,
    reviewType: EvaluationTypeValue,
): CycleEvaluationGroupChild | undefined =>
    [...(group?.cycleEvaluations ?? []), ...(group?.dormantCycleEvaluations ?? [])].find(
        (evaluation) => evaluation.reviewType === reviewType,
    );
